<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Structures</div>
				<div class="modal__head__subtitle">Recommended as default by RICS guidance note. </div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-6">
						<li>Archways, underpasses, culverts</li>
						<li>Bridges over and under</li>
						<li>Buildings/structures at plinth</li>
						<li>Foundations (where exposed)</li>
						<li>Overhead features, canopies, porches, etc</li>
						<li>Garden/mobile/temporary buildings</li>
						<li>Ramps (top and bottom), loading bays, steps (generalised)</li>
						<li>Ruins</li>
						<li>Gullies/Rain water down pipes</li>
					</div>
					<div class="col md-6">
						<li>Rodding eyes</li>
						<li>Masts</li>
						<li>Industrial chimneys</li>
						<li>Electric substations or transformers (perimeter fence only)</li>
						<li>Inspection pits</li>
						<li>Pipe work or ducts (outline only)</li>
						<li>Overhead pipes/cables</li>
						<li>Overhead line tower/masts (visible bases)</li>
						<li>Tanks/storage chambers (outline only)</li>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'StructuresModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/StructuresModal.vue